import * as React from 'react'

function IconEditor() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-black flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
  )
}

function IconImage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-black flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  )
}

function IconRemove() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M6 18L18 6M6 6l12 12" />
    </svg>
  )
}

function IconAdd() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M12 4v16m8-8H4" />
    </svg>
  )
}

function IconLink() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
    </svg>
  )
}

function IconUpload() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
    </svg>
  )
}

function IconError() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  )
}

function IconLoading() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="animate-spin h-4 w-4 text-white flex-none" fill="none" viewBox="0 0 24 24">
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    </svg>
  )
}

export function PostEditorTag(props: { editor: string, onDelete(editor: string): void }) {
  const onDelete = () => props.onDelete(props.editor)

  return (
    <div className="items-center inline-flex pl-2 pr-1.5 py-1 bg-orange-200 rounded-2xl">
      <IconEditor />
      <div className="ml-1.5 mr-1">
        {props.editor}
      </div>
      <button
        onClick={onDelete}
        className="p-0.5 ml-1 cursor-pointer rounded-full bg-red-600 focus:outline-none hover:ring-4 hover:ring-red-600 hover:ring-opacity-50">
        <IconRemove />
      </button>
    </div>
  )
}

export function PostEditorCreate(props: { exists(editor: string): boolean, onAdd(editor: string): void }) {
  const [editor, setEditor] = React.useState('')

  const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => e.key === 'Enter' && onSubmit()

  const onInput = (e: React.FormEvent<HTMLInputElement>) => setEditor(e.currentTarget.value)

  const onSubmit = () => {
    if (editor.length > 0 && !props.exists(editor)) {
      props.onAdd(editor)
      setEditor('')
    }
  }

  return (
    <div className="items-center inline-flex pl-2 pr-1.5 py-1 bg-orange-200 rounded-2xl">
      <IconEditor />
      <input
        onKeyPress={onKeyPress} onInput={onInput}
        type="text" placeholder="茶后谈编辑 ID" value={editor}
        className="w-28 h-6 px-1 ml-1 mr-0.5 border-0 shadow-none bg-orange-100 placeholder-gray-400" />
      <button
        onClick={onSubmit}
        disabled={editor.length === 0 || props.exists(editor)}
        className="p-0.5 ml-1 cursor-pointer rounded-full bg-green-600 disabled:opacity-50 disabled:ring-0 focus:outline-none hover:ring-4 hover:ring-green-600 hover:ring-opacity-50">
        <IconAdd />
      </button>
    </div>
  )
}

export function PostImageTag(props: { id: string, size: [number, number], detached: boolean, url: string, onDelete(id: string, detached: boolean): Promise<void> }) {
  const [width, height] = props.size, sizeText = `${width} × ${height}`

  const onLink = () => window.open(props.url)!

  const onDelete = () => props.onDelete(props.id, props.detached)

  return (
    <div className="items-center inline-flex pl-2 pr-1.5 py-1 bg-orange-200 rounded-2xl">
      <IconImage />
      <div className="ml-1.5 mr-1">{sizeText}</div>
      <button
        onClick={onLink}
        className="p-0.5 ml-1 cursor-pointer rounded-full bg-green-600 focus:outline-none hover:ring-4 hover:ring-green-600 hover:ring-opacity-50">
        <IconLink />
      </button>
      <button onClick={onDelete} className="p-0.5 ml-1.5 cursor-pointer rounded-full bg-red-600 focus:outline-none hover:ring-4 hover:ring-red-600 hover:ring-opacity-50">
        <IconRemove />
      </button>
    </div>
  )
}

export function PostImageCreate(props: { onUpload(blob: Blob): Promise<void> }) {
  type State = { type: 'prepare' } | { type: 'uploading' | 'error', sizeText: string }

  const [state, setState] = React.useState<State>({ type: 'prepare' })

  const onFileSelect = (files: FileList | null) => {
    const file = files ? files[0] : null
    if (file) {
      const reader = new FileReader(), img = document.createElement('img')
      reader.onloadend = (e) => img.src = e.target?.result as string ?? ''
      img.onload = () => {
        const sizeText = `${img.width} × ${img.height}`
        setState({ type: 'uploading', sizeText })
        fetch(img.src)
          .then((r) => r.blob())
          .then((b) => props.onUpload(b))
          .then(() => setState({ type: 'prepare' }))
          .catch(() => setState({ type: 'error', sizeText }))
      }
      reader.readAsDataURL(file)
    }
  }

  const onRemove = () => setState({ type: 'prepare' })

  const onInputChange = (e: React.FormEvent<HTMLInputElement>) => onFileSelect(e.currentTarget.files)

  return (
    <div className="items-center inline-flex pl-2 pr-1.5 py-1 bg-orange-200 rounded-2xl">
      <IconImage />
      {state.type === 'prepare' ? (
        <div className="h-6 px-1 ml-1 mr-0.5 justify-center bg-orange-100 text-gray-400">点击按钮上传图片</div>
      ) : (
        <div className="h-6 px-1 ml-1 mr-0.5 justify-center bg-orange-100">{state.sizeText}</div>
      )}
      {state.type === 'prepare' ? (
        <label className="ml-1 h-5">
          <div className="flex flex-col p-0.5 cursor-pointer rounded-full bg-green-600 disabled:opacity-50 disabled:ring-0 focus:outline-none hover:ring-4 hover:ring-green-600 hover:ring-opacity-50">
            {<IconUpload />}
          </div>
          <input className="flex flex-col w-0 opacity-0" type="file" accept="image/bmp, image/jpeg, image/png, image/webp;" onChange={onInputChange} />
        </label>
      ) : state.type === 'uploading' ? (
        <button disabled className="p-0.5 ml-1 cursor-pointer rounded-full bg-green-600 disabled:opacity-50 disabled:ring-0 focus:outline-none hover:ring-4 hover:ring-green-600 hover:ring-opacity-50">
          {<IconLoading />}
        </button>
      ) : (
        <button disabled className="p-0.5 ml-1 cursor-pointer rounded-full bg-orange-600 disabled:opacity-50 disabled:ring-0 focus:outline-none hover:ring-4 hover:ring-orange-600 hover:ring-opacity-50">
          {<IconError />}
        </button>
      )}
      <button onClick={onRemove} disabled={state.type !== 'error'} className="p-0.5 ml-1.5 cursor-pointer rounded-full bg-red-600 disabled:opacity-50 disabled:ring-0 focus:outline-none hover:ring-4 hover:ring-red-600 hover:ring-opacity-50">
        <IconRemove />
      </button>
    </div>
  )
}
